export default __webpack_public_path__ + "static/media/circleArrowUpSolid.1274ebab.svg";